import { parseBooleanValue } from "../../util";
import { IAttachmentType } from "../model/AttachmentType";

const AttachmentTypeParamMapper = (item: IAttachmentType) => {
  return {
    ...item,
    anonymisationRequired: parseBooleanValue(item.anonymisationRequired),
    valid: parseBooleanValue(item.valid)
  };
};

export default AttachmentTypeParamMapper;
